export default {
  List: {
    EmptyTitle: "Chưa có bản ghi",
    Empty: "Chưa có bản ghi nào trên hệ thống, thêm bản ghi để quản lý",
    Title: "Kiểm kê",
    AddButton: "Lập kiểm kê",
    Synthetic: "Tổng hợp kiểm kê",
    Search: "Tìm kiếm biên bản kiểm kê",
    DeleteTitle: "Xóa biên bản kiểm kê",
    Delete: "Dữ liệu bị xóa sẽ không thể khôi phục. Bạn có chắc chắn muốn xóa?",
  },
  AddNew: {
    Add: "Lập lịch kiểm kê",
    Description: "Nội dung ",
    AuditType: "Loại",
    IsAudit: "Kiểm kê",
    IsTally: "Kiểm đếm",
    OrganizationUnit: "Đơn vị",
    Location: "Vị trí tài sản",
    AuditStartDate: "Ngày bắt đầu",
    AuditEndDate: "Đến ngày",
    AssetCategory: "Nhóm tài sản",
    Participants: "Thành phần tham gia",
    IsAuditByLocation: "Kiểm kê theo vị trí tài sản",
    AuditByDetail: "Kiểm kê chi tiết",
    AuditQuantity: "Kiểm kê số lượng",
    ButtonCancel: "Hủy bỏ",
    ButtonAccept: "Đồng ý",
    WarringAuditExitPeriod:
      "Đã tồn tại kỳ kiểm kê có cùng kỳ, đơn vị quản lý, vị trí, nhóm tài sản. Vui lòng kiểm tra lại.",
  },
  StartAudit: {
    Title: "Bắt đầu kiểm kê",
    Content1: "Khi thực hiện chức năng này, lịch kiểm kê sẽ được đổi trạng thái thành ",
    Status: "Đang thực hiện ",
    Content2: "và bạn có thể bắt đầu kiểm kê và nhập kết quả theo các cách sau:",
    Content3: "Cài đặt ứng dụng ",
    App: "Thông báo ",
    Content4: "Trên điện thoại",
    Content5: "Thực hiện kiểm kê bằng điện thoại và đồng bộ dữ liệu từ mobile",
    Content6: "Xuất khẩu danh sách tài sản",
    Content7: "Thực hiện kiểm kê thủ công và nhập khẩu kết quả kiểm kê",
    Guide: "Xem hướng dẫn",
    Export: "Xuất khẩu ngay",
    NotShowAgain: "Đã hiểu, không hiển thị lần sau",
    Close: "Đóng",
    Start: "Bắt đầu kiểm kê",
  },
  ListTab: {
    GeneralInfo: "Thông tin chung",
    AuditList: "Danh sách tài sản kiểm kê",
    Participants: "Thành phần tham gia",
    AssetOther: "Tài sản ngoài danh sách",
    Result: "Kết quả xử lý",
  },
  TabContent: {
    Description: "Nội dung ",
    AuditType: "Loại kiểm kê ",
    IsAudit: "Kiểm kê",
    IsTally: "Kiểm đếm",
    OrganizationUnit: "Đơn vị",
    Location: "Vị trí tài sản",
    AuditStartDate: "Ngày bắt đầu",
    AuditEndDate: "Ngày kết thúc",
    AssetType: "Nhóm tài sản",
    Participants: "Thành phần tham gia",
    IsAuditByLocation: "Kiểm kê theo vị trí tài sản",
  },
  LayoutGrid: {
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    Status: "Tình trạng",
    Amount: "Số lượng",
    RealAmount: "Số lượng thực tế",
    CurrentStatus: "Hiện trạng tài sản",
    Treatment: "Biện pháp xử lý",
    Employee: "Nhân viên",
    OrganizationUnit: "Phòng ban",
    Role: "Vai trò",
  },
  AuditTest: {
    QuantityDifference: "Chênh lệch số lượng",
    ChangeAllocation: "Thay đổi đối tượng sử dụng",
    ChangeLocation: "Thay đổi vị trí tài sản",
    LowQuality: "Kém chất lượng",
    AssetsOffTheList: "Tài sản ngoài danh sách",
    SumQuantity: "Tổng số lượng",
    AssetType: "Loại tài sản",
    AssetLocation: "Vị trí tài sản",
    Participants: "Thành phần tham gia",
    GroupFor: "Nhóm cột theo",
    Synchronized: "Đồng bộ từ mobile",
    InputRes: "Nhập kết quả",
  },
  AuditSynchronized: {
    Title: "Chọn cách thức đồng bộ",
    Content: "Khi đồng bộ phát hiện các tài sản đã kiểm kê",
    Option1: "Cập nhật kết quả kiểm kê theo dữ liệu mới nhất",
    Option2: "Bỏ qua, giữ nguyên kết quả kiểm kê đã có",
    Synchronized: "Đồng bộ dữ liệu",
    Cancel: "Hủy",
  },
  AuditDetailDone: {
    Title: "Hoàn thành kiểm kê",
    Content2: 'Bạn có muốn chuyển lịch kiểm kê thành "Đã kiểm kê"?',
    Warning: "Khi hoàn thành kiểm kê thì sẽ không được sửa lại thông tin",
    Statistical: "Thống kê chênh lệch tài sản sau kiểm kê",
    Difference: "Xem chênh lệch",
    Close: "Để sau",
    Processed: "Đã xử lý",
    AssetAudit: "Tài sản kiểm kê (0)",
    AssetOutList: "Tài sản ngoài danh sách (0)",
    Participants: "Thành phần tham gia (0)",
    OrganizationUnit: "Phòng ban",
  },
  AuditDetailDiff: {
    TitleDiff: "Chênh lệch tài sản sau kiểm kê",
    HandleDifference: "Xử lý chênh lệch",
  },
  AuditDetailYet: {
    GroupType: "Nhóm cột theo",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    SerialNumber: "Số Seri",
    User: "Người sử dụng",
    AssetType: "Loại tài sản",
    Specification: "Quy cách tài sản",
    AuditStatus: "Tình trạng kiểm kê",
    Auditor: "Người kiểm kê",
    AuditDate: "Ngày kiểm kê",
    ProcessingStatus: "Tình trạng xử lý",
    Quality: "Chất lượng",
    Description: "Ghi chú",
    SumQuantity: "Tổng số lượng",
    Ledger: "Sổ sách",
    Real: "Thực tế",
    Difference: "Chênh lệch",
    Quantity: "Số lượng",
    AssetStatus: "Tình trạng",
    LocationCode: "Mã vị trí TS",
    LocationCodeTooltip: "Mã vị trí tài sản",
    LocationName: "Vị trí tài sản",
    AllocationType: "Đối tượng sử dụng",
    EmployeeCode: "Mã nhân viên SD",
    EmployeeCodeTooltip: "Mã nhân viên sử dụng",
    EmployeeName: "Nhân viên sử dụng",
    UsedOrganizationUnitCode: "Mã phòng ban SD",
    UsedOrganizationUnitCodeTooltip: "Mã phòng ban sử dụng",
    UsedOrganizationUnitName: "Phòng ban sử dụng",
    RepresentativeCode: "Mã người ĐD",
    RepresentativeCodeTooltip: "Mã người đại diện",
    RepresentativeName: "Người đại diện",
    UseInfo: "Thông tin sử dụng",
    LowQuality: "Chất lượng kém",
    AssetOutList: "Danh sách tài sản ngoài danh sách",
    Participant: "Người tham gia",
    StartAudit: "Bắt đầu kiểm kê",
    Edit: "Sửa",
    Delete: "Xóa",
    Member: "Người tham gia",
    ParticipantOrganizationUnit: "Phòng ban",
    Role: "Vai trò",
    AddMember: "Thêm dòng",
    Done: "Hoàn thành kiểm kê",
    AssetTypeCode: "Mã loại tài sản",
    AssetTypeName: "Tên loại tài sản",
    TotalQuantity: "Tổng số lượng",
    UnUse: "Chưa sử dụng",
    Use: "Đang sử dụng",
    Broken: "Đã hỏng",
    ReportBroken: "Báo hỏng",
    Repair: "Đang sửa chữa",
    Maintain: "Đang bảo dưỡng",
    ReportLost: "Báo mất",
    RequestLiquidation: "Đề nghị thanh lý",
    ToDate: "Đến ngày",
    Period: "Kỳ",
    AuditType: "Loại",
    ManagerUnit: "Đơn vị quản lý",
    Location: "Vị trí tài sản",
    AssetCategory: "Nhóm",
    StatusAudit: "Tình trạng",
    ExportAsset: "Xuất khẩu tài sản",
    AuditByDetail: "Kiểm kê chi tiết",
    AuditByQuantity: "Kiểm kê số lượng",
    OrganizationUnit: "Phòng ban",
    Employee: "Nhân viên",
    TitleAuditDetailYet: "Kiểm kê tài sản {0} {1}/{2}",
    Code: "Mã",
    AssetAudit: "Tài sản kiểm kê",
    AuditMember: "Thành viên tham gia",
    WarningSelectedAsset: "Tài sản đã có trong danh sách",
    WarningDeleteAudit: "Bạn có chắc chắn muốn xóa lịch kiểm kê này?",
    WarningDeleteMember: "Bạn có chắc chắn muốn xóa thành viên này?",
    WarningDuplicateMember: "Thành viên tham gia bị trùng. Vui lòng kiểm tra lại.",
  },
  AuditExportAsset: {
    ExportListAuditAsset: "Xuất khẩu danh sách tài sản kiểm kê",
    TypeExport: "Chọn hình thức xuất khẩu danh sách tài sản",
    AllInOne: "Tất cả tài sản ra một file",
    EachAssetType: "Mỗi loại tài sản ra một file",
    EachLocation: "Mỗi vị trí tài sản ra một file",
    EachUseOrganizationUnit: "Mỗi phòng ban sửa dụng ra một file",
    ButtonCancel: "Hủy bỏ",
    ButtonExport: "Xuất khẩu",
  },
  AuditGuide: {
    TitleGuide1:
      "Thêm thành viên tham gia kiểm kê, những người được thêm sẽ được xem lịch kiểm kê này",
    TitleGuide2: "Xuất khẩu danh sách tài sản kiểm kê",
    TitleGuide3: "Bấm vào đây để bắt đầu thực hiện kiểm kê",
  },
  ImportAuditResult: {
    FileName: "Tên tệp tin",
    Result: "Kết quả",
    Reason: "Lý do",
    DownloadFile: "Tải tệp lỗi",
  },
  AuditIncrement: {
    Title: "Ghi tăng tài sản",
    IncrementDate: "Ngày ghi tăng",
    ReportNo: "Số biên bản",
    IncrementReason: "Lý do ghi tăng",
    IncrementQuantity: "SL ghi tăng",
    LedgerQuantityWhenAudit: "SL sổ sách khi kiểm",
    CurrentLedgerQuantity: "SL sổ sách hiện tại",
    RealQuantityWhenAudit: "SL thực tế khi kiểm",
    AssetType: "Loại tài sản",
    LocationCode: "Mã vị trí",
    EmployeeCode: "Mã nhân viên SD",
    Employee: "Nhân viên SD",
    AllocationUnitCode: "Mã phòng ban SD",
    AllocationUnit: "Phòng ban SD",
    RepresentCode: "Mã người ĐD",
    DefaultReason: "Ghi tăng sau kiểm kê",
    AssetNotFound: "Phải chọn ít nhất 1 tài sản",
    CloseQuestion: "Bạn có muốn ngừng xử lý tài sản?",
  },
  AuditDecrement: {
    Title: "Ghi giảm tài sản",
    DecrementReason: "Lý do ghi giảm",
    DecrementDate: "Ngày ghi giảm",
    DecrementQuantity: "SL ghi giảm",
    DefaultReason: "Ghi giảm sau kiểm kê",
  },
};
